import {
    SET_CITY,
    SET_DISTRICT,
    SET_WARD
} from "@/stores/mutations";

export const mutations = {

    [SET_CITY](state, data) {
        state.cities = data;
    },

    [SET_DISTRICT](state, data) {
        state.districts = data;
    },

    [SET_WARD](state, data) {
        state.wards = data;
    },
}
